(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-silk-day-night"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ln-silk-moments')) {
    customElements.define('ln-silk-moments', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.grid = this.querySelector('.ln-silk-day-night__grid');
        this.cards = Array.from(this.querySelectorAll('.ln-silk-day-night__card'));
        this.dots = Array.from(this.querySelectorAll('[data-sn-index]'));
        this.pagination = this.querySelector('.ln-silk-day-night__pagination');
        if (!this.grid) return;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.mobile = matchMedia('(max-width: 749px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.pagination.hidden = this.cards.length < 2;
        this.dots.forEach((button, index) => button.addEventListener('click', () => this.show(index), {signal}));
        this.grid.addEventListener('scroll', () => this.queue(), {signal, passive:true});
        this.grid.addEventListener('keydown', event => {
          if (!this.mobile.matches || event.target !== this.grid) return;
          const rtl = getComputedStyle(this.grid).direction === 'rtl';
          let target;
          if (event.key === 'ArrowRight') target = this.current + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') target = this.current + (rtl ? 1 : -1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.cards.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.show(target);
        }, {signal});
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.snBlockId === event.detail.blockId);
          if (index >= 0) this.show(index, true);
        }, {signal});
        this.mobile.addEventListener('change', () => this.queue(), {signal});
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => this.queue());
          this.resize.observe(this.grid);
        }
        this.current = 0;
        this.queue();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        this.resize?.disconnect();
        cancelAnimationFrame(this.raf);
        this.raf = 0;
      }
      show(index, instant = false) {
        if (!this.mobile.matches || !this.cards.length) return;
        index = Math.max(0, Math.min(this.cards.length - 1, index));
        const card = this.cards[index];
        const rtl = getComputedStyle(this.grid).direction === 'rtl';
        const viewport = this.grid.getBoundingClientRect();
        const target = card.getBoundingClientRect();
        const delta = rtl ? target.right - viewport.right : target.left - viewport.left;
        this.grid.scrollBy({left:delta, behavior:instant || this.motion.matches ? 'instant' : 'smooth'});
      }
      queue() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          const viewport = this.grid.getBoundingClientRect();
          const rtl = getComputedStyle(this.grid).direction === 'rtl';
          let distance = Infinity, current = 0;
          this.cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect();
            const gap = Math.abs(rtl ? rect.right - viewport.right : rect.left - viewport.left);
            if (gap < distance) {distance = gap;current = index;}
          });
          this.current = current;
          this.dots.forEach((button, index) => {
            if (index === current) button.setAttribute('aria-current', 'true');
            else button.removeAttribute('aria-current');
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luminova-pillow-scroll-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ln-pillow-scroll-story')) {
    customElements.define('ln-pillow-scroll-story', class extends HTMLElement {
      connectedCallback() {
        if (this.connected) return;
        this.connected = true;
        this.events = new AbortController();
        this.mobile = matchMedia('(max-width: 720px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.clip = this.querySelector('video');
        this.frame = this.querySelector('.ln-pillow-story__frame');
        this.panels = Array.from(this.querySelectorAll('[data-ps-panel]'));
        this.meter = this.querySelector('.ln-pillow-story__meter');
        this.loading = this.querySelector('.ln-pillow-story__loading');
        this.percent = this.querySelector('[data-ps-percent]');
        this.serial = 0;
        const opts = { signal: this.events.signal };
        const queue = () => this.queue();
        window.addEventListener('scroll', queue, { ...opts, passive: true });
        window.addEventListener('resize', queue, opts);
        document.addEventListener('visibilitychange', queue, opts);
        this.clip.addEventListener('seeked', queue, opts);
        this.clip.addEventListener('loadeddata', () => {
          clearTimeout(this.mediaTimer);
          this.setAttribute('data-video-ready', '');
          this.loading.hidden = true;
          this.queue();
        }, opts);
        this.clip.addEventListener('error', () => {
          if (this.clip.getAttribute('src')) this.staticMode();
        }, opts);
        this.mobile.addEventListener('change', () => this.configure(), opts);
        this.motion.addEventListener('change', () => this.configure(), opts);
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-ps-jump]');
          if (!link || !this.hasAttribute('data-enhanced') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.jump(Number(link.dataset.psJump), true);
        }, opts);
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.pinned = index;
          this.jump(index, false);
        }, opts);
        this.addEventListener('shopify:block:deselect', () => { this.pinned = null; this.queue(); }, opts);
        ['pointerdown', 'touchstart', 'keydown'].forEach(name => {
          this.addEventListener(name, () => this.unlock(), { ...opts, passive: true });
        });
        this.configure();
      }
      disconnectedCallback() {
        this.connected = false;
        this.events?.abort();
        this.release();
        cancelAnimationFrame(this.raf);
        this.raf = 0;
      }
      release() {
        this.serial = (this.serial || 0) + 1;
        this.fetcher?.abort();
        this.observer?.disconnect();
        clearTimeout(this.fetchTimer);
        clearTimeout(this.mediaTimer);
        clearTimeout(this.focusTimer);
        if (this.clip) { this.clip.pause(); this.clip.removeAttribute('src'); this.clip.load(); }
        if (this.blobURL) URL.revokeObjectURL(this.blobURL);
        this.blobURL = null;
        this.removeAttribute('data-video-ready');
        this.loading.hidden = true;
        this.unlocked = false;
        this.loadingStarted = false;
      }
      configure() {
        this.release();
        this.source = this.mobile.matches ? this.dataset.mobileSrc || this.dataset.desktopSrc : this.dataset.desktopSrc || this.dataset.mobileSrc;
        if (!this.source || this.motion.matches || !this.panels.length) { this.staticMode(); return; }
        this.setAttribute('data-enhanced', '');
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) this.preload();
            this.queue();
          }, { rootMargin: '400px 0px' });
          this.observer.observe(this);
        } else this.preload();
        this.queue();
      }
      staticMode() {
        this.release();
        this.removeAttribute('data-enhanced');
        this.panels.forEach(panel => {
          panel.inert = false;
          panel.removeAttribute('aria-hidden');
          panel.style.opacity = '';
          panel.style.transform = '';
          panel.style.pointerEvents = '';
        });
      }
      preload() {
        if (this.loadingStarted || !this.hasAttribute('data-enhanced')) return;
        this.loadingStarted = true;
        this.loading.hidden = false;
        this.percent.textContent = '0%';
        const serial = this.serial;
        const current = () => this.connected && this.serial === serial;
        const attach = src => {
          if (!current() || this.clip.getAttribute('src')) return;
          this.clip.src = src;
          this.clip.load();
          this.mediaTimer = setTimeout(() => { if (current() && this.clip.readyState < 2) this.staticMode(); }, 12000);
        };
        if (!window.fetch || !window.URL?.createObjectURL) { attach(this.source); return; }
        this.fetcher = new AbortController();
        this.fetchTimer = setTimeout(() => {
          if (!current()) return;
          this.fetcher.abort();
          attach(this.source);
        }, 15000);
        fetch(this.source, { signal: this.fetcher.signal, credentials: 'omit' }).then(async response => {
          if (!response.ok || !response.body) throw new Error('Video unavailable');
          const total = Number(response.headers.get('content-length')) || 0;
          if (total > 40000000) throw new Error('Use native buffering');
          const reader = response.body.getReader(), chunks = [];
          let received = 0;
          for (;;) {
            const { done, value } = await reader.read();
            if (!current()) { await reader.cancel(); return null; }
            if (done) break;
            chunks.push(value);
            received += value.byteLength;
            if (received > 40000000) { await reader.cancel(); throw new Error('Use native buffering'); }
            this.percent.textContent = total ? `${Math.min(100, Math.round(received / total * 100))}%` : '';
          }
          return new Blob(chunks, { type: 'video/mp4' });
        }).then(blob => {
          if (!current() || !blob || this.clip.getAttribute('src')) return;
          clearTimeout(this.fetchTimer);
          this.blobURL = URL.createObjectURL(blob);
          attach(this.blobURL);
        }).catch(() => {
          if (!current()) return;
          clearTimeout(this.fetchTimer);
          attach(this.source);
        });
      }
      queue() {
        if (this.raf || !this.connected || !this.hasAttribute('data-enhanced')) return;
        this.raf = requestAnimationFrame(() => { this.raf = 0; this.paint(); });
      }
      cue(index) {
        if (this.panels.length === 3) return [0, .49, .91][index] || 0;
        return this.panels.length > 1 ? index / (this.panels.length - 1) : 0;
      }
      paint() {
        if (!this.hasAttribute('data-enhanced')) return;
        const rect = this.getBoundingClientRect();
        const top = parseFloat(getComputedStyle(this.frame).top) || 0;
        const span = Math.max(1, this.offsetHeight - this.frame.offsetHeight);
        const progress = Math.max(0, Math.min(1, (top - rect.top) / span));
        this.progress = progress;
        this.meter.style.transform = `scaleX(${progress})`;
        const smooth = value => { const t = Math.max(0, Math.min(1, value)); return t * t * (3 - 2 * t); };
        this.panels.forEach((panel, index) => {
          let opacity;
          if (this.pinned != null) opacity = this.pinned === index ? 1 : 0;
          else if (this.panels.length === 3) {
            const cues = [[0, 0, .15, .23], [.35, .43, .57, .65], [.77, .85, 1.1, 1.2]][index];
            const enter = index === 0 ? 1 : smooth((progress - cues[0]) / (cues[1] - cues[0]));
            opacity = enter * (1 - smooth((progress - cues[2]) / (cues[3] - cues[2])));
          } else {
            const center = this.cue(index);
            opacity = this.panels.length === 1 ? 1 : 1 - smooth(Math.abs(progress - center) / .28);
          }
          panel.style.opacity = String(opacity);
          panel.style.transform = `translate3d(0,${(1 - opacity) * 22 * (progress > this.cue(index) ? -1 : 1)}px,0)`;
          panel.style.pointerEvents = opacity > .6 ? 'auto' : 'none';
          panel.inert = opacity <= .6;
          panel.setAttribute('aria-hidden', opacity > .6 ? 'false' : 'true');
        });
        const duration = this.clip.duration;
        if (document.hidden || rect.bottom <= top || rect.top >= innerHeight || !Number.isFinite(duration) || this.clip.readyState < 2 || this.clip.seeking) return;
        const target = Math.min(progress * duration, Math.max(0, duration - .045));
        const gap = target - this.clip.currentTime;
        if (Math.abs(gap) > .018) {
          try { this.clip.currentTime += Math.abs(gap) < .07 ? gap : gap * .18; } catch (_) { return; }
          this.queue();
        }
      }
      unlock() {
        if (this.unlocked || !this.hasAttribute('data-enhanced') || this.clip.readyState < 2) return;
        this.unlocked = true;
        const serial = this.serial;
        const promise = this.clip.play();
        if (promise?.then) promise.then(() => { if (serial === this.serial) { this.clip.pause(); this.queue(); } }).catch(() => { this.unlocked = false; });
        else this.clip.pause();
      }
      jump(index, focus) {
        const panel = this.panels[index];
        if (!panel) return;
        if (!this.hasAttribute('data-enhanced')) { panel.scrollIntoView({ block: 'center' }); return; }
        const top = parseFloat(getComputedStyle(this.frame).top) || 0;
        const start = scrollY + this.getBoundingClientRect().top - top;
        const span = this.offsetHeight - this.frame.offsetHeight;
        window.scrollTo({ top: start + span * this.cue(index), behavior: focus && !this.motion.matches ? 'smooth' : 'instant' });
        clearTimeout(this.focusTimer);
        if (focus) this.focusTimer = setTimeout(() => {
          if (!this.connected || panel.inert) return;
          panel.querySelector('.ln-pillow-story__heading').focus({ preventScroll: true });
        }, 900);
        this.queue();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
